const envConfig = {
	api_url: process.env.REACT_APP_API_URL,
	platform: process.env.REACT_APP_PLATFORM
}

module.exports = envConfig;